const envs = {
  development: {
    // apiUrl: "/",
    // loginPrefix: "",
    // apiPrefix: "",
    // keycloak: {
    //  client_id: "",
    //  client_secret: "",
    //  grant_type: "",
    //  scope: "",
    // },
    apiUrl: "https://mservice-test.cma.lavazza.com/",
    loginPrefix: "",
    apiPrefix: "apiconsumerapp",
    keycloak: {
      client_id: "bo_spa_client",
      client_secret: "gRvilV1uk1EDxjiPxWzjNBQ5ldtJx4Nc",
      grant_type: "password",
      scope: "openid",
    },
    keycloakSSO: {
      client_id: "sso_client",
      client_secret: "3QxhokYfP704WoYkFZms2of6y5ylhV9Z",
      grant_type: "authorization_code",
      scope: "openid",
    },
  },
  quality: {
    apiUrl: "https://mservice-test.cma.lavazza.com/",
    loginPrefix: "",
    apiPrefix: "apiconsumerapp/backoffice/",
    keycloak: {
      client_id: "bo_spa_client",
      client_secret: "gRvilV1uk1EDxjiPxWzjNBQ5ldtJx4Nc",
      grant_type: "password",
      scope: "openid",
    },
    keycloakSSO: {
      client_id: "sso_client",
      client_secret: "3QxhokYfP704WoYkFZms2of6y5ylhV9Z",
      grant_type: "authorization_code",
      scope: "openid",
    },
    
  },
  preprod: {
    apiUrl: "https://mservice-pre.cma.lavazza.com/",
    apiPrefix: "apiconsumerapp/backoffice/",
    loginPrefix: "",
    keycloak: {
      client_id: "bo_spa_client",
      client_secret: "vHiQpysywYdcJrwFy6Ljzi3cZ7jGU7wF",
      grant_type: "password",
      scope: "openid",
    },
    keycloakSSO: {
      client_id: "sso_client",
      client_secret: "3QxhokYfP704WoYkFZms2of6y5ylhV9Z",
      grant_type: "authorization_code",
      scope: "openid",
    },
  },
  production: {
    apiUrl: "https://mservice.cma.lavazza.com/",
    apiPrefix: "apiconsumerapp/backoffice/",
    loginPrefix: "",
    keycloak: {
      client_id: "bo_spa_client",
      client_secret: "JiCcJ9aPo2BlB2PN6jgqQAcGfPJo7Sfp",
      grant_type: "password",
      scope: "openid",
    },
    keycloakSSO: {
      client_id: "sso_client",
      client_secret: "tAK7JXTugU3li8O4y3lhLIV1T6PQzN4B",
      grant_type: "authorization_code",
      scope: "openid",
    },
  },
};

export default envs[process.env.REACT_APP_ENV];
